import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useFormik } from 'formik';
import { translatedMessage } from '../../service/LanguageService';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { CompetitionService } from '../../service/CompetitionService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { InputTextarea } from 'primereact/inputtextarea';

const defaulNewValue = {
    id: null,
    name: '',
    proofingMethod: '',
}

const CompetitionOtherCompetencyEditDialog = (props) => {
    const [otherCompetency, setOtherCompetency] = useState({});
    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        // console.log("props: ", props)
        let _otherCompetency = props.otherCompetency ? props.otherCompetency : { ...defaulNewValue, competition: { id: props?.competition?.id } }
        setOtherCompetency(_otherCompetency);

    }, [props]);

    // Form
    const formik = useFormik({
        initialValues: otherCompetency,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};

            // console.log("validate: ", data)

            if (!data.name || data.name.trim() === '') {
                errors.name = translatedMessage("form.error.nameRo.required");
            }

            if (!data.proofingMethod || data.proofingMethod.trim() === '') {
                errors.proofingMethod = translatedMessage('form.error.competition.otherCompetency.proofingMethod.required');
            }


            return errors;
        },
        onSubmit: (data) => {
            let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
            // console.log("saved data: ", _data)

            competitionService.saveCompetitionOtherCompetency(_data)
                .then(savedOtherCompetency => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(savedOtherCompetency, true);
                    }
                    handleDialogClose()
                })
                .catch(error => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(null, false, error);
                    }
                });
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage("generic.cancel")} icon="pi pi-times" className="p-button-text" onClick={() => handleDialogClose()} />
            <Button label={translatedMessage("generic.save")} icon="pi pi-check" className="p-button-text" form="otherCompetency-form" type="submit" />
        </>
    )

    const handleDialogClose = () => {
        props.onClose()
        formik.resetForm()
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                closable={true}
                onHide={handleDialogClose}
                header={translatedMessage("competition.requirements.otherCompetency")}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
            >
                <form id="otherCompetency-form" onSubmit={formik.handleSubmit}>
                    <div className="input-panel flex flex-column mb-5">
                        <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <InputText type="text" name="name" id="name"
                                    value={formik.values.name} onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('name') })} />
                                <label htmlFor="name" className={classNames({ 'p-error': isFormFieldValid('name') })}>
                                    {translatedMessage("generic.nameRo")} *
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('name')}

                        <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <InputTextarea type="text" id="proofingMethod" name="proofingMethod" value={formik.values?.proofingMethod}
                                    onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('proofingMethod') })}
                                    rows={5} cols={30} autoResize
                                    maxLength={10000}
                                    tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                    tooltipOptions={{ position: 'top' }} />
                                <label htmlFor="proofingMethod" className={classNames({ 'p-error': isFormFieldValid('proofingMethod') })}>
                                    {translatedMessage("competition.requirements.otherCompetency.proofing")} *
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('proofingMethod')}
                    </div>
                </form>
            </Dialog>
        </>
    );
};

export default CompetitionOtherCompetencyEditDialog;
